module.exports = __webpack_public_path__ + "img/not-authorized.840b9720.svg";